<template>
  <v-container>
    <div class="d-flex justify-space-between align-baseline mb-4 px-2">
      <div class="pb-6 text-h5">
        <v-icon left>mdi-clipboard-text-outline</v-icon>
        {{ $t("categories.inspection.form") }}
      </div>
    </div>
    <v-row>
      <v-col>
        <v-card>
          <v-card-text :style="{ minHeight: '500px' }">
            <v-row>
              <v-col class="d-flex">
                <div class="text-h5">{{ $t("categories.inspection.fill") }}</div>
              </v-col>
              <v-col
                class="d-flex"
                cols="12"
                md="4"
                lg="3"
              >
                <v-btn
                  color="warning"
                  @click="signForm()"
                  :loading="loading"
                  :disabled="signDisabled || !isNotModified"
                  :v-if="role === 'inspector' || role === 'operator'"
                  class="mr-2"
                >
                  <template v-if="formFinalized">
                    <v-icon left>mdi-lock</v-icon>
                    {{ $t("commons.finalized") }}
                  </template>
                  <template v-else> <v-icon left>mdi-clipboard-check</v-icon> Sign </template>
                </v-btn>
                <v-btn
                  color="success"
                  @click="saveInspectionForm"
                  :loading="loading"
                  :disabled="formFinalized || isNotModified || !formValid"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  {{ $t("commons.save") }}
                </v-btn>
              </v-col>
            </v-row>
            <InspectionProcessForm
              v-model="inspectionForm"
              :role="role"
              :finalized="formFinalized"
              @formValid="updateFormValid"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from "lodash"

import { InspectionProcessForm } from "@/components"
import { InspectionService } from "@/services"
import { INSPECTION_FORM_MODEL } from "@/utils/consts"
import { mkInspection } from "@/utils/datamodels"

export default {
  name: "InspectionMeetingCreateUpdate",
  components: {
    InspectionProcessForm
  },
  data() {
    return {
      role: null,
      inspection: mkInspection(),
      inspectionForm: INSPECTION_FORM_MODEL,
      loading: false,
      refInspection: null,
      canClick: false,
      formValid: true
    }
  },
  computed: {
    isNotModified() {
      return _.isEqual(this.refInspection, this.inspectionForm)
    },
    id() {
      return this.$route.params.id
    },
    signDisabled() {
      return (
        (this.role === "administrator" && !!this.inspectionForm.inspector_signature_date) ||
        (this.role === "inspector" && !!this.inspectionForm.inspector_signature_date) ||
        (this.role === "operator" && !!this.inspectionForm.operator_signature_date) ||
        this.loading
      )
    },
    formFinalized() {
      return (
        !!this.inspectionForm.inspector_signature_date &&
        !!this.inspectionForm.operator_signature_date
      )
    }
  },
  methods: {
    saveInspectionForm() {
      this.loading = true
      InspectionService.form
        .patch(this, this.inspection.id, this.inspectionForm)
        .then(r => {
          this.inspectionForm = _.omit(r, [
            "id",
            "role",
            "created_by",
            "created_at",
            "updated_by",
            "updated_at"
          ])
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.updated", {
              entity: this.$t("categories.inspection.form")
            }),
            color: "success"
          })
          this.refInspection = _.cloneDeep(this.inspectionForm)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getInspectionForm() {
      InspectionService.form.get(this, this.id).then(r => {
        this.inspectionForm = _.omit(r, [
          "id",
          "role",
          "created_by",
          "created_at",
          "updated_by",
          "updated_at"
        ])
        this.refInspection = _.cloneDeep(this.inspectionForm)
        this.role = r.role
      })
    },
    getInspection() {
      this.loading = true
      InspectionService.get(this, null, this.id)
        .then(r => {
          this.inspection = r
          this.getInspectionForm()
        })
        .finally(_ => {
          this.loading = false
        })
    },
    signForm() {
      this.loading = true
      this.canClick = true
      InspectionService.form
        .sign(this, this.id)
        .then(r => {
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.signed", {
              entity: this.$t("categories.inspection.form")
            }),
            color: "success"
          })
          this.getInspectionForm()
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateFormValid(value) {
      this.formValid = value
    }
  },
  created() {
    this.getInspection()
  }
}
</script>
